(() => {
  if (customElements.get('loris-frequence-pdp')) return;
  class LorisFrequencePdp extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.start = () => this.mount();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.start, { once: true, signal: this.controller.signal });
      else this.mount();
    }
    fragment(name) {
      return this.querySelector(`[data-frequence-${name}]`).content.cloneNode(true);
    }
    mount() {
      this.main = document.querySelector('.t4s-section-main-product');
      this.info = this.main?.querySelector('.t4s-product__info-container');
      this.row = this.main?.querySelector('.t4s-row__product');
      this.gallery = this.main?.querySelector('[data-main-media]');
      const title = this.info?.querySelector('h1');
      const price = this.info?.querySelector('.t4s-product__price-review');
      const formArea = this.info?.querySelector('.t4s-product-form__variants');
      if (!title || !price || !formArea || !this.gallery || !this.row || this.main.dataset.frequenceMounted) return;
      this.main.dataset.frequenceMounted = 'true';
      this.info.prepend(this.fragment('heading'));
      this.heading = this.info.querySelector('.frequence-hero-heading');
      title.textContent = this.dataset.name;
      this.heading.querySelector('[data-frequence-title]').replaceWith(title);
      price.after(this.fragment('summary'));
      formArea.after(this.fragment('purchase'));
      if (this.dataset.available !== 'true') formArea.setAttribute('data-frequence-native-hidden', '');
      const nativeButton = this.info.querySelector('.t4s-product-form__submit');
      if (this.dataset.available === 'true') {
        const label = nativeButton?.querySelector('.t4s-btn-atc_text');
        if (label) label.textContent = this.dataset.add;
      }
      this.viewport = window.matchMedia('(max-width: 1024px)');
      this.positionHeading = () => {
        if (this.viewport.matches) this.row.prepend(this.heading);
        else this.info.prepend(this.heading);
      };
      this.positionHeading();
      this.viewport.addEventListener('change', this.positionHeading, { signal: this.controller.signal });
      this.gallery.after(this.fragment('progress'));
      this.gallery.setAttribute('aria-label', this.dataset.gallery);
      this.gallery.setAttribute('role', 'region');
      const updateGallery = () => {
        const slides = Array.from(this.gallery.querySelectorAll('[data-main-slide]:not(.is--media-hide)'));
        const selected = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-selected')));
        const count = slides.length;
        const progress = this.main.querySelector('.frequence-gallery-progress');
        if (progress && count <= 1) progress.hidden = true;
        if (progress && count > 1) {
          progress.style.setProperty('--frequence-progress', `${(selected + 1) / count * 100}%`);
          const text = `${selected + 1} / ${count}`;
          const countNode = progress.querySelector('[data-frequence-count]');
          if (countNode.textContent !== text) countNode.textContent = text;
        }
        this.gallery.querySelector('.previous')?.setAttribute('aria-label', this.dataset.previous);
        this.gallery.querySelector('.next')?.setAttribute('aria-label', this.dataset.next);
      };
      this.galleryObserver = new MutationObserver(updateGallery);
      this.galleryObserver.observe(this.gallery, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
      updateGallery();
      document.body.append(this.fragment('sticky'));
      this.sticky = document.querySelector('.frequence-sticky');
      const action = this.info.querySelector('.frequence-prebook') || nativeButton;
      this.stickyObserver = new IntersectionObserver(entries => {
        const entry = entries[0];
        this.sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
        this.queueDock?.();
      }, { threshold: 0 });
      if (action) this.stickyObserver.observe(action);
      this.sticky.querySelector('[data-frequence-proxy]')?.addEventListener('click', () => {
        if (nativeButton && !nativeButton.disabled) nativeButton.click();
      }, { signal: this.controller.signal });
      this.mountDock();
      this.translateReviewAction();
      this.mountVideos();
      document.documentElement.classList.add('loris-frequence-ready');
    }
    mountDock() {
      this.toolbar = document.querySelector('.t4s-toolbar');
      this.whatsapp = document.querySelector('.whatsapp-float');
      this.originalWhatsapp = ['inset-block-end', 'z-index'].map(name => ({ name, value: this.whatsapp?.style.getPropertyValue(name) || '', priority: this.whatsapp?.style.getPropertyPriority(name) || '' }));
      const root = document.documentElement;
      const restoreWhatsapp = () => {
        if (!this.whatsapp) return;
        this.originalWhatsapp.forEach(({ name, value, priority }) => {
          if (value) this.whatsapp.style.setProperty(name, value, priority);
          else this.whatsapp.style.removeProperty(name);
        });
      };
      this.restoreDock = () => {
        restoreWhatsapp();
        root.style.removeProperty('--frequence-dock-bottom');
        root.style.removeProperty('--frequence-purchase-space');
      };
      const syncDock = () => {
        this.dockFrame = null;
        if (!this.viewport.matches) { this.restoreDock(); return; }
        const toolbarStyle = this.toolbar && getComputedStyle(this.toolbar);
        const toolbarBox = this.toolbar?.getBoundingClientRect();
        const toolbarVisible = toolbarBox && toolbarBox.height > 0 && toolbarStyle.display !== 'none' && toolbarStyle.visibility !== 'hidden' && toolbarBox.top < window.innerHeight && toolbarBox.bottom >= window.innerHeight - 4;
        const bottom = toolbarVisible ? `${Math.ceil(window.innerHeight - toolbarBox.top)}px` : 'env(safe-area-inset-bottom, 0px)';
        root.style.setProperty('--frequence-dock-bottom', bottom);
        root.style.setProperty('--frequence-purchase-space', `${this.sticky.hidden ? 0 : Math.ceil(this.sticky.getBoundingClientRect().height)}px`);
        if (this.whatsapp) {
          this.whatsapp.style.setProperty('inset-block-end', `calc(${bottom} + 14px)`, 'important');
          this.whatsapp.style.setProperty('z-index', '192', 'important');
        }
      };
      this.queueDock = () => { if (this.dockFrame == null) this.dockFrame = requestAnimationFrame(syncDock); };
      this.dockObserver = new ResizeObserver(this.queueDock);
      if (this.toolbar) this.dockObserver.observe(this.toolbar);
      this.dockObserver.observe(this.sticky);
      window.addEventListener('resize', this.queueDock, { signal: this.controller.signal });
      window.addEventListener('orientationchange', this.queueDock, { signal: this.controller.signal });
      this.viewport.addEventListener('change', this.queueDock, { signal: this.controller.signal });
      this.queueDock();
    }
    translateReviewAction() {
      const widget = document.querySelector('#judgeme_product_reviews');
      if (!widget || widget.dataset.productId !== this.dataset.productId) return;
      const translate = () => {
        const link = widget.querySelector('.jdgm-write-rev-link');
        if (!link) return;
        const label = link.getAttribute('aria-expanded') === 'true'
          ? (document.documentElement.lang.startsWith('ar') ? 'إلغاء التقييم' : 'Cancel review')
          : this.dataset.write;
        if (link.textContent !== label) link.textContent = label;
      };
      this.reviewObserver = new MutationObserver(translate);
      this.reviewObserver.observe(widget, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-expanded'] });
      translate();
    }
    mountVideos() {
      const videos = Array.from(document.querySelectorAll('.frequence-vibe-video'));
      if (!videos.length) return;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const play = async video => {
        if (this.motion.matches || document.hidden || video.dataset.visible !== 'true') {
          video.pause();
          video.classList.remove('is-playing');
          return;
        }
        if (!video.dataset.loaded) {
          video.querySelectorAll('source[data-frequence-src]').forEach(source => { source.src = source.dataset.frequenceSrc; });
          video.dataset.loaded = 'true';
          video.load();
        }
        video.muted = true;
        try { await video.play(); video.classList.add('is-playing'); }
        catch { video.classList.remove('is-playing'); }
      };
      this.videoObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => { entry.target.dataset.visible = String(entry.isIntersecting); play(entry.target); });
      }, { rootMargin: '100px' });
      videos.forEach(video => this.videoObserver.observe(video));
      const refresh = () => videos.forEach(play);
      this.motion.addEventListener('change', refresh, { signal: this.controller.signal });
      document.addEventListener('visibilitychange', refresh, { signal: this.controller.signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.galleryObserver?.disconnect();
      this.reviewObserver?.disconnect();
      this.stickyObserver?.disconnect();
      this.videoObserver?.disconnect();
      this.dockObserver?.disconnect();
      if (this.dockFrame != null) cancelAnimationFrame(this.dockFrame);
      this.restoreDock?.();
      this.sticky?.remove();
    }
  }
  customElements.define('loris-frequence-pdp', LorisFrequencePdp);
})();
